import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'modules/core'
import { selectTotalCredits } from '../slices/credit-balance.slice'
import { openTopUpModal, type TopUpSource } from '../slices/revenue-cat.slice'

/**
 * Credit-side mirror of `useSubscriptionGate`. Guards a paid action: when the
 * balance can't cover `cost`, it opens the TopUpModal (the eager buy push) and
 * returns false so the caller aborts; otherwise returns true and the action
 * proceeds. Use only at explicit, user-initiated generation triggers where a
 * credit is known to be spent (not on chat sends — text is free and the media
 * decision happens server-side; that path relies on the reactive
 * `insufficient_credits` handler instead).
 */
export function useCreditGate() {
  const dispatch = useAppDispatch()
  const totalCredits = useAppSelector(selectTotalCredits)

  const gate = useCallback(
    (source: TopUpSource = 'generate_gate', cost = 1): boolean => {
      if (totalCredits < cost) {
        dispatch(openTopUpModal({ source }))
        return false
      }
      return true
    },
    [totalCredits, dispatch]
  )

  return { gate }
}
